module.exports = __webpack_public_path__ + "img/contentUs-location-icon.c5acca23.svg";